import './styles/flexoki.css'
import './styles/app.css'
import { createApp, watch } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { i18n, setLocale } from './i18n'
import { configureAuth } from './api/http'
import { useSession } from './stores/session'

const dark = window.matchMedia('(prefers-color-scheme: dark)')
const applyTheme = () => document.documentElement.classList.toggle('dark', dark.matches)
applyTheme()
dark.addEventListener('change', applyTheme)

const app = createApp(App).use(createPinia()).use(i18n)
const session = useSession()

configureAuth({
  getToken: () => session.token,
  refresh: () => session.refresh(),
  onAuthLost: () => {
    session.clear()
    const here = router.currentRoute.value
    if (!here.meta.public) router.push({ path: '/login', query: { redirect: here.fullPath } })
  },
})

// The user's profile locale wins once known; guests keep the stored/browser locale.
watch(() => session.user?.locale, (l) => l && setLocale(l), { immediate: true })
document.documentElement.lang = i18n.global.locale.value

app.use(router).mount('#app')
